export const AppRouting = {
  Error403: {
    path: () => "/403",
  },
  Error404: {
    path: () => "/404",
  },
  Dashboard: {
    path: () => "/",
  },
  Quests: {
    path: () => "/quests",
  },
  AddQuest: {
    path: () => "/quests/add",
  },
  Challenges: {
    path: () => "/challenges",
  },
  AddChallenge: {
    path: () => "/challenges/add",
  },
  Rewards: {
    path: () => "/rewards",
  },
  AddReward: {
    path: () => "/rewards/add",
  },
  Players: {
    path: () => "/players",
  },
  Leaderboard: {
    path: () => "/leaderboard",
  },
  Requests: {
    path: () => "/requests",
  },
  Notifications: {
    path: () => "/notifications",
  },
} as const;

type RouteObject<T extends any[] = any[]> = {
  route?: string;
  path: (...args: T) => string;
};

export const getRoute = <T extends RouteObject>(routeObj: T): string => {
  return routeObj.route ?? routeObj.path();
};

export const getPathnameAndSearch = (location: {
  pathname: string;
  search: string;
}) => {
  return `${location.pathname}${location.search}`;
};
